import { render, staticRenderFns } from "./createsmsconfig.vue?vue&type=template&id=c7c41dcc&"
import script from "./createsmsconfig.vue?vue&type=script&lang=ts&"
export * from "./createsmsconfig.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "createsmsconfig.vue"
export default component.exports